import React, { Component } from 'react'

import placeholderImage from '../../../assets/download.jpeg'; // FOR TESTING PURPOSES ONLY

export default class ListItem extends Component {
  render() {

      let inactiveClass = '';

      if (this.props.inactive) {
          inactiveClass = 'inactive';
      }

    return (
        <div className={`item ${inactiveClass}`} onClick = {this.props.clickFunc}>
            <div className="image">
                <img src={this.props.image} />
            </div>
            {this.props.name}
        </div>
    )
  }
}
